import { useEffect, useState } from "react";
import { PageHeader } from "../components/Layout";
import { api } from "../lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/audit-logs?limit=300")
      .then((r) => setItems(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Failed to load audit log"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Immutable trail of all operator actions." testid="audit-header" />
      <div className="p-6 sm:p-8">
        {err && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 text-sm" data-testid="audit-error">{String(err)}</div>}
        <div className="border border-gray-200 bg-white overflow-x-auto">
          <table className="ps-table" data-testid="audit-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Actor</th>
                <th>Role</th>
                <th>Action</th>
                <th>Target</th>
                <th>Meta</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="text-center py-10 text-gray-400">Loading…</td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-gray-400">No audit entries yet.</td></tr>}
              {items.map((a) => (
                <tr key={a.id} data-testid={`audit-row-${a.id}`}>
                  <td className="font-mono text-gray-700">{new Date(a.created_at).toLocaleString()}</td>
                  <td className="font-mono">{a.actor_email}</td>
                  <td><span className="ps-pill ps-pill-neutral"><span className="dot" />{a.actor_role}</span></td>
                  <td className="font-mono font-semibold">{a.action}</td>
                  <td className="font-mono text-gray-500">{a.target_type} / {a.target_id?.slice(0, 8)}…</td>
                  <td className="font-mono text-xs text-gray-500 max-w-[320px] truncate">{JSON.stringify(a.meta || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
